import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Button,
  Typography,
  TextField,
  Divider,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  Autocomplete,
  FormHelperText,
} from "@mui/material";
import CustomTable from "../../components/table/Table";
import { useDispatch, useSelector } from "react-redux";
import SearchButton from "../../components/search/Search";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloudUpload from "../../components/button/Cloudupload";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getregion } from "../../slices/setting";
import { createcustomer } from "../../slices/customer";
import { deleteenquiry } from "../../slices/enquiry";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { getcities, getcountries, getstates } from "../../slices/country";

const Addcustomer = ({ setLoader, show }) => {
  let { state } = useLocation();
  const [panfile, setPanFile] = useState(null);
  const [aadharfile, setAadharFile] = useState(null);
  const [licenccefile, setLicenceFile] = useState(null);
  const user = JSON.parse(localStorage.getItem('user'));
  const { countries, staties, cities } = useSelector((state) => state.country);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [customerdata, setCustomerdata] = useState({
    "other_proof": []
})

  // Initialize formik with validation schema
  const formik = useFormik({
    initialValues: {
      customer_type: "Business",
      title: "Mr",
      first_name: "",
      last_name: "",
      email: "",
      customer_phone_mobile: "",
      customer_phone_work: "",
      gst_number: "",
      business_name: "",
      contact_person_name: "",
      billing_country: "",
      billing_state: "",
      billing_address: "",
      billing_city: "",
      billing_pincode: "",
      shipping_country: "",
      shipping_state: "",
      shipping_address: "",
      shipping_city: "",
      shipping_pincode: "",
      pan_no: "",
      aadhar_no: "",
      licence_no: "",
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required('First name is required'),
      last_name: Yup.string().required('Last name is required'),
      billing_country: Yup.string().required('Country is required'),
      billing_state: Yup.string().required('State is required'),
      billing_address: Yup.string().required('Address is required'),
      billing_city: Yup.string().required('City is required'),
      billing_pincode: Yup.string()
        .matches(/^[0-9]{6}$/, 'Pincode must be 6 digits')
        .required('Pincode is required'),
      shipping_country: Yup.string().required('Country is required'),
      shipping_state: Yup.string().required('State is required'),
      shipping_address: Yup.string().required('Address is required'),
      shipping_city: Yup.string().required('City is required'),
      shipping_pincode: Yup.string()
        .matches(/^[0-9]{6}$/, 'Pincode must be 6 digits')
        .required('Pincode is required'),
      pan_no: Yup.string()
        .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Invalid PAN Number')
        .required('PAN Number is required'),
      aadhar_no: Yup.string()
        .matches(/^[0-9]{12}$/, 'Aadhar Number must be 12 digits')
        .required('Aadhar Number is required'),
      licence_no: Yup.string().required('Licence Number is required'),
    }),
    onSubmit: (values) => {
      setLoader(true);
      const customerData = {
        dealer_id: user.dealer_id,
        customer_type: values.customer_type,
        title: values.title,
        first_name: values.first_name,
        last_name: values.last_name,
        email: values.email,
        customer_phone_mobile: values.customer_phone_mobile,
        customer_phone_work: values.customer_phone_work,
        gst_number: values.gst_number,
        pan_no: values.pan_no,
        aadhar_no: values.aadhar_no,
        licence_no: values.licence_no,
        pan_doc: panfile,
        aadhar_doc: aadharfile,
        licence_doc: licenccefile,
        other_proof: customerdata.other_proof
      };

      const billingAddress = {
        country: values.billing_country,
        state: values.billing_state,
        address: values.billing_address,
        city: values.billing_city,
        pincode: values.billing_pincode
      };

      const shippingAddress = {
        country: values.shipping_country,
        state: values.shipping_state,
        address: values.shipping_address,
        city: values.shipping_city,
        pincode: values.shipping_pincode
      };

      dispatch(createcustomer({...customerData, billing_address: billingAddress, shipping_address: shippingAddress}))
        .then(() => {
          navigate("/customer");
          setLoader(false);
          if(state?.cusData){
            const e_id = state?.cusData?.id
            dispatch(deleteenquiry({e_id}))
          }
        })
        .catch(() => {
          setLoader(false);
        });
    },
  });

  // Set form values from state.cusData if available
  useEffect(() => {
    if(state?.cusData) {
      formik.setValues({
        ...formik.values,
        customer_type: state.cusData.customer_type || "Business",
        title: state.cusData.title || "Mr",
        first_name: state.cusData.first_name || "",
        last_name: state.cusData.last_name || "",
        email: state.cusData.email || "",
        customer_phone_mobile: state.cusData.phone || "",
        customer_phone_work: state.cusData.alt_phone || "",
        gst_number: state.cusData.gst_number || "",
      });
    }
  }, [formik, state]);

  const copyAddress = () => {
    formik.setValues({
      ...formik.values,
      shipping_country: formik.values.billing_country,
      shipping_state: formik.values.billing_state,
      shipping_address: formik.values.billing_address,
      shipping_city: formik.values.billing_city,
      shipping_pincode: formik.values.billing_pincode
    });
  };

  const arrowBack = () => {
    navigate(-1);
  };

  const updateOtherProof = (e, index) => {
    const value = e.target.value;
    setCustomerdata((prevData) => ({
      ...prevData, 
      other_proof: prevData.other_proof.map((proof, i) =>
        i === index ? { ...proof, name: value } : proof
      ),
    }));
  }

  const addProof = () =>{
    setCustomerdata({...customerdata, other_proof:[...customerdata.other_proof, {name:"", doc:""}]})
  }

    useEffect(() => {
      dispatch(getcountries());
    }, []);

  return (
    <div className="content" style={{ marginLeft: show ? "220px" : "10px" }}>
      <Box 
        component="form"
        noValidate
        autoComplete="off"
        onSubmit={formik.handleSubmit}
      >
        <Grid container spacing={3} sx={{ paddingBottom: 2, alignItems: "center" }}>
          <Grid
            item
            xs={12}
            sx={{
              paddingTop: 0,
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <ArrowBackIcon onClick={arrowBack} sx={{ cursor: "pointer" }} />
            <Typography variant="h5" sx={{fontWeight:'bold'}}>Create New Customer</Typography>
          </Grid>
          <Grid item xs={8} sx={{ paddingTop: 3 }}>
            <Grid container spacing={2} sx={{alignItems:'center'}}>
                <Grid item xs={4}>
                  <Typography>Customer Type *</Typography>
                </Grid>
                <Grid item xs={8}>
                  <FormControl fullWidth>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="customer_type"
                      value={formik.values.customer_type}
                      onChange={formik.handleChange}
                    >
                      <FormControlLabel
                        value="Business"
                        control={<Radio />}
                        label="Business"
                      />
                      <FormControlLabel
                        value="Individual Customer"
                        control={<Radio />}
                        label="Individual Customer"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <Typography>Customer Name *</Typography>
                </Grid>
                <Grid item xs={8}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 1
                    }}
                  >
                    <FormControl size="small" sx={{ minWidth: 80 }}>
                      <Select
                        name="title"
                        value={formik.values.title}
                        onChange={formik.handleChange}
                      >
                        <MenuItem selected value="Mr">Mr</MenuItem>
                        <MenuItem value="Miss">Miss</MenuItem>
                        <MenuItem value="Mrs">Mrs</MenuItem>
                      </Select>
                    </FormControl>
                    <TextField
                        size="small"
                        fullWidth
                        placeholder="First Name"
                        variant="outlined"
                        name="first_name"
                        value={formik.values.first_name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        onBeforeInput={(e) => {
                          if (!/^[a-zA-Z\s]*$/.test(e.data)) {
                            e.preventDefault();
                          }
                        }}
                        error={formik.touched.first_name && Boolean(formik.errors.first_name)}
                        helperText={formik.touched.first_name && formik.errors.first_name}
                      />                      

                    <TextField
                      size="small"
                      fullWidth
                      placeholder="Last Name"
                      variant="outlined"
                      name="last_name"
                      value={formik.values.last_name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      onBeforeInput={(e) => {
                      if (!/^[a-zA-Z\s]*$/.test(e.data)) {
                              e.preventDefault();
                        }
                      }}
                      error={formik.touched.last_name && Boolean(formik.errors.last_name)}
                      helperText={formik.touched.last_name && formik.errors.last_name}
                    />
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Typography>Customer Email</Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                    size="small"
                    fullWidth
                    placeholder="test@gmail.com"
                    variant="outlined"
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Typography>Customer Phone *</Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                    size="small"
                    fullWidth
                    placeholder="Enter Contact Number"
                    variant="outlined"
                    name="customer_phone_mobile"
                    value={formik.values.customer_phone_mobile}
                    onChange={formik.handleChange}
                    onBeforeInput={(e) => {
                          if (!/^[0-9\s]*$/.test(e.data)) {
                            e.preventDefault();
                          }
                        }}
                        inputProps={{
    inputMode: 'numeric',
    pattern: '[1-9]',
    maxLength: 5,
  }}
                    onBlur={formik.handleBlur}
                    error={formik.touched.customer_phone_mobile && Boolean(formik.errors.customer_phone_mobile)}
                    helperText={formik.touched.customer_phone_mobile && formik.errors.customer_phone_mobile}
                  />
                </Grid>
                {formik.values.customer_type === "Business" ?
                <>
                <Grid item xs={4}>
                <Typography >GST Number *</Typography>
                </Grid>
                <Grid item xs={8}>
                <TextField
                size="small"
                fullWidth
                id="outlined-basic"
                placeholder="Enter GST Number"
                variant="outlined"
                name="gst_number"
                value={formik.values.gst_number}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                onBeforeInput={(e) => {
                  if (!/^[a-zA-Z0-9\s]*$/.test(e.data)) {
                    e.preventDefault();
                  }
                }}
                error={formik.touched.gst_number && Boolean(formik.errors.gst_number)}
                helperText={formik.touched.gst_number && formik.errors.gst_number}
              />
                </Grid>
                <Grid item xs={4}>
                <Typography >Business Name *</Typography>
                </Grid>
                <Grid item xs={8}>
                <TextField
                size="small"
                fullWidth
                id="outlined-basic"
                placeholder="Enter Business Name"
                variant="outlined"
                value={formik.values.business_name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.business_name && Boolean(formik.errors.business_name)}
                helperText={formik.touched.business_name && formik.errors.business_name}
              />
                </Grid>
                <Grid item xs={4}>
                <Typography >Contact Person Name *</Typography>
                </Grid>
                <Grid item xs={8}>
                <TextField
                size="small"
                fullWidth
                id="outlined-basic"
                placeholder="Enter Contact Person Name"
                variant="outlined"
                value={formik.values.contact_person_name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.contact_person_name && Boolean(formik.errors.contact_person_name)}
                helperText={formik.touched.contact_person_name && formik.errors.contact_person_name}
              />
                </Grid>
                </>
                :
                <>
                <Grid item xs={4}>
                <Typography >Customer Alt Phone *</Typography>
                </Grid>
                <Grid item xs={8}>
                <TextField
                size="small"
                fullWidth
                id="outlined-basic"
                placeholder="Enter Contact Number"
                variant="outlined"
                value={formik.values.customer_phone_work}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.customer_phone_work && Boolean(formik.errors.customer_phone_work)}
                helperText={formik.touched.customer_phone_work && formik.errors.customer_phone_work}
              />
                </Grid>
                </>
                }
            </Grid>
          </Grid>
        </Grid>
        <Grid container columnSpacing={5} sx={{mt: 2}}>
                  <Grid item xs={6}>
                  <Grid container spacing={2} sx={{ alignItems:'center'}}>
                  <Grid item xs={12}>
                <Typography variant="h6">Billing Address</Typography>
                </Grid>
                <Grid item xs={4}>
                <Typography >Country/Region *</Typography>
                </Grid>
                <Grid item xs={8}>
                <Autocomplete
                  size="small"
                  disablePortal
                  id="combo-box-demo"
                  options={countries || []}
                  value={countries.filter(va => va.name === formik.values.billing_country)[0] || null}
                  getOptionLabel={(option) => option.name}
                  onChange={(event, value) => {
                    formik.setFieldValue('billing_country', value?.name);
                    dispatch(getstates(value?.name));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Country"
                      name="billing_country"
                      onBlur={formik.handleBlur}
                      error={formik.touched.billing_country && Boolean(formik.errors.billing_country)}
                      helperText={formik.touched.billing_country && formik.errors.billing_country}
                    />
                  )}
                />
                </Grid>
                <Grid item xs={4}>
                <Typography >State *</Typography>
                </Grid>
                <Grid item xs={8}>
                                <Autocomplete
                                sx={{p: 0}}
                  size="small"
                  disablePortal
                  id="combo-box-demo"
                  options={staties || []}
                  value={staties?.filter(va => va.name === formik.values.billing_state)[0] || null}
                  getOptionLabel={(option) => option.name}
                  onChange={(event, value) => {
                    formik.setFieldValue('billing_state', value.name);
                    const paydata = {
                    "country": formik.values.billing_country,
                    "state": value.name
                    }
                
                    dispatch(getcities(paydata));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select State"
                      name="billing_state"
                      onBlur={formik.handleBlur}
                      error={formik.touched.billing_state && Boolean(formik.errors.billing_state)}
                      helperText={formik.touched.billing_state && formik.errors.billing_state}
                    />
                  )}
                />
                </Grid>
                <Grid item xs={4}>
                <Typography >Address *</Typography>
                </Grid>
                <Grid item xs={8}>
                <TextField
                size="small"
                fullWidth
                name="billing_address"
                id="outlined-basic"
                variant="outlined"
                value={formik.values.billing_address}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.billing_address && Boolean(formik.errors.billing_address)}
                helperText={formik.touched.billing_address && formik.errors.billing_address}
              />
                </Grid>
                <Grid item xs={4}>
                <Typography >City *</Typography>
                </Grid>
                <Grid item xs={8}>
                                <Autocomplete
                  size="small"
                  disablePortal
                  id="combo-box-demo"
                  options={cities || []}
                  value={formik.values.billing_city || null}
                  getOptionLabel={(option) => option}
                  onChange={(event, value) => {
                    formik.setFieldValue('billing_city', value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select City"
                      name="billing_city"
                      onBlur={formik.handleBlur}
                      error={formik.touched.billing_city && Boolean(formik.errors.billing_city)}
                      helperText={formik.touched.billing_city && formik.errors.billing_city}
                    />
                  )}
                />
                </Grid>
                <Grid item xs={4}>
                <Typography >Pincode *</Typography>
                </Grid>
                <Grid item xs={8}>
                <TextField
                size="small"
                fullWidth
                id="outlined-basic"
                variant="outlined"
                name="billing_pincode"
                value={formik.values.billing_pincode}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.billing_pincode && Boolean(formik.errors.billing_pincode)}
                helperText={formik.touched.billing_pincode && formik.errors.billing_pincode}
                onBeforeInput={(e) => {
                          if (!/^[0-9\s]*$/.test(e.data)) {
                            e.preventDefault();
                          }
        }}
              />
                </Grid>
                  </Grid>
            </Grid>
            <Grid item xs={6}>
                  <Grid container spacing={2} sx={{ alignItems:'center'}}>
                  <Grid item xs={12}>
                <Typography variant="h6">Shipping Address, <span onClick={copyAddress} style={{fontSize: '14px', color:'red', cursor:'pointer'}}>Copy Billing address here</span></Typography>
                </Grid>
                <Grid item xs={4}>
                <Typography >Country/Region *</Typography>
                </Grid>
                <Grid item xs={8}>
                <Autocomplete
                  size="small"
                  disablePortal
                  id="combo-box-demo"
                  options={countries || []}
                  value={countries.filter(va => va.name === formik.values.shipping_country)[0] || null}
                  getOptionLabel={(option) => option.name}
                  onChange={(event, value) => {
                    formik.setFieldValue('shipping_country', value?.name);
                    dispatch(getstates(value?.name));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Country"
                      name="shipping_country"
                      onBlur={formik.handleBlur}
                      error={formik.touched.shipping_country && Boolean(formik.errors.shipping_country)}
                      helperText={formik.touched.shipping_country && formik.errors.shipping_country}
                    />
                  )}
                />
                </Grid>
                <Grid item xs={4}>
                <Typography >State *</Typography>
                </Grid>
                <Grid item xs={8}>
                                <Autocomplete
                                sx={{p: 0}}
                  size="small"
                  disablePortal
                  id="combo-box-demo"
                  options={staties || []}
                  value={staties?.filter(va => va.name === formik.values.shipping_state)[0] || null}
                  getOptionLabel={(option) => option.name}
                  onChange={(event, value) => {
                  formik.setFieldValue('shipping_state', value.name);
                  const paydata = {
                    "country": formik.values.shipping_country,
                    "state": value.name
                  }
                  dispatch(getcities(paydata));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select State"
                      name="shipping_state"
                      onBlur={formik.handleBlur}
                      error={formik.touched.shipping_state && Boolean(formik.errors.shipping_state)}
                      helperText={formik.touched.shipping_state && formik.errors.shipping_state}
                    />
                  )}
                />
                </Grid>
                <Grid item xs={4}>
                <Typography >Address *</Typography>
                </Grid>
                <Grid item xs={8}>
                <TextField
                size="small"
                fullWidth
                id="outlined-basic"
                variant="outlined"
                value={formik.values.shipping_address}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.shipping_address && Boolean(formik.errors.shipping_address)}
                helperText={formik.touched.shipping_address && formik.errors.shipping_address}
              />
                </Grid>
                <Grid item xs={4}>
                <Typography >City *</Typography>
                </Grid>
                <Grid item xs={8}>
                                <Autocomplete
                  size="small"
                  disablePortal
                  id="combo-box-demo"
                  options={cities || []}
                  value={formik.values.shipping_city || null}
                  getOptionLabel={(option) => option}
                  onChange={(event, value) => {
                    formik.setFieldValue('shipping_city', value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select City"
                      name="shipping_city"
                      onBlur={formik.handleBlur}
                      error={formik.touched.shipping_city && Boolean(formik.errors.shipping_city)}
                      helperText={formik.touched.shipping_city && formik.errors.shipping_city}
                    />
                  )}
                />
                </Grid>
                <Grid item xs={4}>
                <Typography >Pincode *</Typography>
                </Grid>
                <Grid item xs={8}>
                <TextField
                size="small"
                fullWidth
                id="outlined-basic"
                variant="outlined"
                value={formik.values.shipping_pincode}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.shipping_pincode && Boolean(formik.errors.shipping_pincode)}
                helperText={formik.touched.shipping_pincode && formik.errors.shipping_pincode}
                onBeforeInput={(e) => {
                    if (!/^[0-9\s]*$/.test(e.data)) {
                          e.preventDefault();
                    }
                }}
              />
                </Grid>
                  </Grid>
            </Grid>
          </Grid>

            <Grid container columnSpacing={5} sx={{mt: 2}}>
                  <Grid item xs={6}>
                  <Grid container spacing={2} sx={{ alignItems:'center'}}>
                  <Grid item xs={12}>
                <Typography variant="h6">Documents</Typography>
                </Grid>
                <Grid item xs={4}>
                <Typography >PAN No *</Typography>
                </Grid>
                <Grid item xs={8}>
                <TextField
                size="small"
                fullWidth
                id="outlined-basic"
                variant="outlined"
                name="pan_no"
                placeholder="Enter PAN Number"
                value={formik.values.pan_no}
                onChange={(e) => {
                  formik.setFieldValue('pan_no', e.target.value.toUpperCase());
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.pan_no && Boolean(formik.errors.pan_no)}
                helperText={formik.touched.pan_no && formik.errors.pan_no}
              />
                </Grid>
                <Grid item xs={4}>
                <Typography >Upload Proof</Typography>
                </Grid>
                <Grid item xs={8}>
          <CloudUpload setLoader={setLoader} file={formik.values.pan_doc} setFile={setPanFile}/>
                </Grid>
                <Grid item xs={4}>
                <Typography >Aadhar No *</Typography>
                </Grid>
                <Grid item xs={8}>
                <TextField
                size="small"
                fullWidth
                id="outlined-basic"
                variant="outlined"
                name="aadhar_no"
                placeholder="Enter Aadhar Number"
                value={formik.values.aadhar_no}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.aadhar_no && Boolean(formik.errors.aadhar_no)}
                helperText={formik.touched.aadhar_no && formik.errors.aadhar_no}
                onBeforeInput={(e) => {
                  if (!/^[0-9\s]*$/.test(e.data)) {
                    e.preventDefault();
                  }
                }}
              />
                </Grid>
                <Grid item xs={4}>
                <Typography >Upload Proof</Typography>
                </Grid>
                <Grid item xs={8}>
                <CloudUpload setLoader={setLoader} file={formik.values.aadhar_doc} setFile={setAadharFile}/>
                </Grid>
                <Grid item xs={4}>
                <Typography >Licence No *</Typography>
                </Grid>
                <Grid item xs={8}>
                <TextField
                size="small"
                fullWidth
                id="outlined-basic"
                variant="outlined"
                name="licence_no"
                placeholder="Enter Licence Number"
                value={formik.values.licence_no}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.licence_no && Boolean(formik.errors.licence_no)}
                helperText={formik.touched.licence_no && formik.errors.licence_no}
              />
                </Grid>
                <Grid item xs={4}>
                <Typography >Upload Proof</Typography>
                </Grid>
                <Grid item xs={8}>
                <CloudUpload setLoader={setLoader} file={formik.values.licence_doc} setFile={setLicenceFile}/>
                </Grid>
                  </Grid>
            </Grid>
            <Grid item xs={6}>
                  <Grid container spacing={2} sx={{ alignItems:'center'}}>
                  <Grid item xs={12}>
                <Typography variant="h6">Other Proofs</Typography>
                </Grid>
                {customerdata?.other_proof?.map((va, index)=>(
                  <>
                  <Grid item xs={4}>
                <Typography >Proof Name *</Typography>
                </Grid>
                <Grid item xs={8}>
                <TextField
                size="small"
                fullWidth
                id="outlined-basic"
                variant="outlined"
                value={va?.name}
                onChange={(e)=>updateOtherProof(e, index)}
              />
                </Grid>
                <Grid item xs={4}>
                <Typography >Doc *</Typography>
                </Grid>
                <Grid item xs={8}>
          <CloudUpload setLoader={setLoader} file={va.doc} setFile={setPanFile}/>
                </Grid>
                  </>
                ))}
                <Grid item xs={12}>
                    <Button variant="contained" onClick={addProof}>Add Proof</Button>
                </Grid>
                  </Grid>
            </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={12} sx={{textAlign:'end'}}>
                  <Button sx={{mr: 2}} onClick={arrowBack} variant="outlined">Cancel</Button>
                  <Button type="submit" variant="contained">Create New Customer</Button>
                </Grid>
            </Grid>
      </Box>
    </div>
  );
};

export default Addcustomer;